import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

/** The email link's ?confirmed= answer, as a toast. Signed out, `onLogin` takes the person to sign in. */
export const useConfirmedEmailNotice = ({ enabled = true, onLogin }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!enabled) return;
    const params = new URLSearchParams(window.location.search);
    const confirmed = params.get('confirmed');
    if (confirmed === 'true') {
      // Signed in already (sign-in no longer waits on the email): just the news, Home takes them to the app
      const signedIn = !!localStorage.getItem('authToken');
      if (!signedIn) onLogin();
      window.history.replaceState({}, '', window.location.pathname);
      setTimeout(() => {
        toast.success(
          t(
            signedIn
              ? 'notifications.emailConfirmedSignedIn'
              : 'notifications.emailConfirmedSuccess'
          )
        );
      }, 500);
    } else if (confirmed === 'error') {
      window.history.replaceState({}, '', window.location.pathname);
      setTimeout(() => {
        toast.error(t('notifications.emailConfirmedError'));
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
